module.exports = {"370786001":"奎聚街道","370786002":"都昌街道","370786003":"围子街道","370786101":"柳疃镇","370786102":"龙池镇","370786104":"卜庄镇","370786108":"饮马镇","370786109":"北孟镇","370786112":"下营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370786.json
// module id = 1542
// module chunks = 0